import React from 'react';
import hotelIcon from '../assets/hotel.svg';

const HotelRefCard = ({ hotel, checkInDate, checkOutDate, price, points, cpp, addedDate }) => {
  // Calculate nights between check-in and check-out
  const calculateNights = (checkIn, checkOut) => {
    if (!checkIn || !checkOut) return 0;
    const start = new Date(checkIn);
    const end = new Date(checkOut);
    const diffTime = Math.abs(end - start);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  // Format date range
  const formatDateRange = (checkIn, checkOut) => {
    if (!checkIn || !checkOut) return 'Date not set';
    const start = new Date(checkIn);
    const end = new Date(checkOut);
    const startMonth = start.toLocaleDateString('en-US', { month: 'short' });
    const startDay = start.getDate();
    const endMonth = end.toLocaleDateString('en-US', { month: 'short' });
    const endDay = end.getDate();
    const year = end.getFullYear();
    
    if (startMonth === endMonth) {
      return `${startMonth} ${startDay} - ${endDay}, ${year}`;
    } else {
      return `${startMonth} ${startDay} - ${endMonth} ${endDay}, ${year}`;
    }
  };

  // Format added date
  const formatAddedDate = (date) => {
    if (!date) return 'Date not set';
    const added = new Date(date);
    const month = added.toLocaleDateString('en-US', { month: 'short' });
    const day = added.getDate();
    const year = added.getFullYear();
    return `${month} ${day}, ${year}`;
  };

  const nights = calculateNights(checkInDate, checkOutDate);
  const dateRange = formatDateRange(checkInDate, checkOutDate);
  const addedDateFormatted = formatAddedDate(addedDate);

  return (
    <div className="relative h-full flex flex-col">
      {/* Main card */}
      <div className="bg-white shadow-md rounded-lg p-4 flex flex-col h-full">
        {/* Top section */}
        <div className="flex items-start justify-between mb-3">
          <div className="flex items-start space-x-3 flex-1 min-w-0">
            {/* Hotel icon */}
            <div className="w-14 h-14 bg-gray-100 rounded-lg flex items-center justify-center flex-shrink-0">
              <img src={hotelIcon} alt="Hotel" className="w-8 h-8" />
            </div>
            
            {/* Hotel name and date */}
            <div className="min-w-0 flex-1">
              <p className="text-gray-800 text-base leading-tight line-clamp-2" style={{ fontFamily: 'Inter, sans-serif' }}>
                {hotel?.brand || hotel?.name || 'hotel'}
              </p>
              <p className="text-sm mt-2" style={{ fontFamily: 'Inter, sans-serif', color: '#A8A8A8' }}>{dateRange}</p>
            </div>
          </div>
          
          {/* Price */}
          <div className="text-right flex-shrink-0 ml-2">
            <p className="text-base font-medium" style={{ fontFamily: 'Inter, sans-serif', color: '#A8A8A8' }}>
              ${price ? parseFloat(price).toFixed(0) : '0'}
            </p>
          </div>
        </div>
        
        {/* Location and nights */}
        <div className="mb-4">
          <p className="text-gray-700 text-sm" style={{ fontFamily: 'Inter, sans-serif' }}>
            {hotel?.city ? `${nights} ${nights === 1 ? 'night' : 'nights'} • ${hotel.city}${hotel?.country ? `, ${hotel.country}` : ''}` : `${nights} ${nights === 1 ? 'night' : 'nights'}`}
          </p>
        </div>
        
        {/* Spacer to push bottom content down */}
        <div className="flex-1"></div>
        
        {/* Bottom section - points and CPP */}
        <div className="flex justify-between items-center pt-2">
          <div>
            <span className="font-bold text-base" style={{ color: '#548BCB', fontFamily: 'Inter, sans-serif' }}>
              {points ? points.toLocaleString() : '0'}
            </span>
            <span className="text-gray-500 text-xs ml-1" style={{ fontFamily: 'Inter, sans-serif' }}>pts</span>
          </div>
          
          <div>
            <span className="font-bold text-base" style={{ color: '#7395C2', fontFamily: 'Inter, sans-serif' }}>
              {cpp ? cpp.toFixed(2) : '0.0'}
            </span>
            <span className="text-gray-500 text-xs ml-1" style={{ fontFamily: 'Inter, sans-serif' }}>¢</span>
          </div>
        </div>
      </div>
      
      {/* Added date below card */}
      <div className="text-right mt-2">
        <p className="text-gray-400 text-sm" style={{ fontFamily: 'Inter, sans-serif' }}>Added: {addedDateFormatted}</p>
      </div>
    </div>
  );
};

export default HotelRefCard;
